import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const wixCodeConnectionPlugin = createPluginFromSingleComponentPlugin({
    name: 'WixCodeConnectionPlugin',
    pack,
    unpack
})
